// 서버·Firebase 오류를 사장님·기사님 말로 바꾼다 — "internal", "Missing or insufficient permissions." 같은 원문을 화면에 내보내지 않는다(예행연습 01-15, 03-16)
const CONTACT = "계속되면 010-2608-5099로 전화 주세요.";

export function plainError(e: unknown, fallback = "잠시 뒤 다시 시도해 주세요."): string {
  const err = (e || {}) as { code?: string; message?: string };
  const code = String(err.code || "").replace(/^functions\//, "").toLowerCase();
  const msg = String(err.message || "").trim();
  // 서버가 일부러 쓴 한국어 설명(예: "초대 링크 기간이 지났습니다")은 오류 코드가 무엇이든 그대로 보여 준다 — 코드 기준 문구가 진짜 이유를 가리면 안 된다
  if (msg && /[가-힣]/.test(msg) && !/insufficient permissions/i.test(msg)) return msg;
  if (code === "permission-denied" || /insufficient permissions/i.test(msg)) return "이 작업을 할 권한이 없습니다. 사장님 계정으로 다시 로그인해 주세요.";
  if (code === "unauthenticated") return "로그인이 풀렸습니다. 다시 로그인해 주세요.";
  if (code === "unavailable" || code === "deadline-exceeded" || /network|failed to fetch|fetch failed/i.test(msg)) return `인터넷이 불안정합니다. 전파가 잘 잡히는 곳에서 다시 눌러 주세요. ${CONTACT}`;
  if (code === "resource-exhausted") return `잠시 요청이 몰렸습니다. 1분 뒤 다시 눌러 주세요. ${CONTACT}`;
  // 그 밖의 영어 원문(internal 등)은 감춘다
  return `${fallback} ${CONTACT}`;
}
